module.exports = __webpack_public_path__ + "img/ana.07968bec.svg";